export const CONTENT_PAGE_TYPE = {
  MODULE: 'MODULE',
  EXTRA_MODULE_CONCEPT: 'EXTRA_MODULE_CONCEPT',
  CONTENT: 'CONTENT',
  ADVERTISEMENT: 'ADVERTISEMENT',
  QUIZ: 'QUIZ',
  WEBINAR: 'WEBINAR'
};

export const CONTENT_PAGE_TITLES = {
  [CONTENT_PAGE_TYPE.MODULE]: {
    NEW: 'module_editor.create_module',
    EDIT: 'module_editor.edit_module',
    IMPORT: 'import_content.title'
  },
  [CONTENT_PAGE_TYPE.EXTRA_MODULE_CONCEPT]: {
    NEW: 'module_editor.create_extra_module',
    EDIT: 'module_editor.edit_extra_module'
  },
  [CONTENT_PAGE_TYPE.CONTENT]: {
    NEW: 'page_content.create_content',
    EDIT: 'page_content.edit_content'
  },
  [CONTENT_PAGE_TYPE.ADVERTISEMENT]: {
    NEW: 'advertisement_editor.create_advertisement',
    EDIT: 'advertisement_editor.edit_advertisement'
  },
  [CONTENT_PAGE_TYPE.QUIZ]: {
    NEW: 'quiz_editor.create_quiz',
    EDIT: 'quiz_editor.edit_quiz'
  },
  [CONTENT_PAGE_TYPE.WEBINAR]: {
    NEW: 'webinar_editor.create_live',
    EDIT: 'webinar_editor.edit_live'
  }
};

export const getContentPageTitle = (contentPageType, isEditingItem) => {
  return isEditingItem
    ? CONTENT_PAGE_TITLES[contentPageType].EDIT
    : CONTENT_PAGE_TITLES[contentPageType].NEW;
};

export const getModulePageTitle = ({
  isEditingItem,
  isMembership,
  createModuleConceptEnabled,
  isExtraPaidModule
}) => {
  if (isMembership && createModuleConceptEnabled && isExtraPaidModule) {
    return getContentPageTitle(
      CONTENT_PAGE_TYPE.EXTRA_MODULE_CONCEPT,
      isEditingItem
    );
  }

  return getContentPageTitle(CONTENT_PAGE_TYPE.MODULE, isEditingItem);
};
